'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ProductModel = require('./ProductModel.js');

var _ProductModel2 = _interopRequireDefault(_ProductModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appName = 'base.models';

var _module = angular.module(appName, ['ngResource']);

// models


_module.factory('ProductModel', _ProductModel2.default);

exports.default = appName;


//////////////////
// WEBPACK FOOTER
// ./app/base/models/models.js
// module id = 3
// module chunks = 0